import styled, { keyframes } from 'styled-components';

export const LoaderComponent = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.2); /* Adjust the alpha value (0.2) for transparency */
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  &.tableLoader {
    min-height: calc(95vh - 100px);
    height: 100%;
    position: relative;
    top: 10;
    left: 10;
  }
`;
export const Ellipsis1 = keyframes`
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
`;

export const Ellipsis2 = keyframes`
  0% {
    transform: translate(0, 0);
  }
  100% {
    transform: translate(24px, 0);
  }
`;

export const Ellipsis3 = keyframes`
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0);
  }
`;
export const LoginButtonLoaderContainer = styled.div`
  display: inline-block;
  position: relative;
  width: 90px;
  height: auto;
  padding-bottom: 10px;
`;
export const StyledEllipsis = styled.div`
  display: inline-block;
  position: relative;
  width: 50px;
  height: 50px;
`;

export const EllipsisDot = styled.div`
  position: absolute;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: ${({ color }) => color || 'rgb(0,0,0)'};
  animation-timing-function: cubic-bezier(0, 1, 1, 0);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);

  &:nth-child(1) {
    left: 10px;
    animation: ${Ellipsis1} 0.6s infinite;
  }
  &:nth-child(2) {
    left: 10px;
    animation: ${Ellipsis2} 0.6s infinite;
  }
  &:nth-child(3) {
    left: 32px;
    animation: ${Ellipsis2} 0.6s infinite;
  }
  &:nth-child(4) {
    left: 56px;
    animation: ${Ellipsis3} 0.6s infinite;
  }
`;
